module.exports = __webpack_public_path__ + "img/remove.b5ab31f3.svg";